import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default function GroupCombineStatsRadarChart(props) {
  const {
    labels,
    data,
    name,
    otherPlayerdata,
    nameotherplayer,
    chartName,
    max,
  } = props;

  const getDataSetsForChart = () => {
    const datasets = [
      {
        label: name,
        data: data,
        fill: true,
        backgroundColor: "rgba(255,255,0,0.1)",
        pointBackgroundColor: "Red",
        borderColor: "Red",
        borderWidth: 3,
      },
      {
        label: nameotherplayer,
        data: otherPlayerdata,
        fill: true,
        backgroundColor: "rgba(255,255,0,0.1)",
        pointBackgroundColor: "Blue",
        borderColor: "Blue",
        borderWidth: 3,
      },
    ];

    const filteredArray = datasets.map((item) => ({
      ...item,
      data: item.data.map((value) => (value === 0 ? null : value)),
    }));

    return filteredArray;
  };

  return (
    <Box mt={2} mb={2}>
      <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5", padding: "10px" }}>
        <Box sx={{ maxWidth: "500px", maxHeight: "500px", margin: "auto" }}>
          <Radar
            data={{
              labels: labels,
              datasets: getDataSetsForChart(),
            }}
            options={{
              responsive: true,
              spanGaps: true,
              scales: {
                r: {
                  min: 1,
                  // max: max,
                  ticks: {
                    color: "#000",
                  },
                  angleLines: {
                    color: "#96baf2",
                    lineWidth: 2,
                  },
                  grid: {
                    color: "#96baf2",
                    lineWidth: 2,
                  },
                  pointLabels: {
                    color: "#000",
                  },
                },
              },
              plugins: {
                legend: {
                  onClick: null,
                  labels: {
                    color: "#000",
                    font: { size: 14 },
                  },
                },
                tooltip: {
                  callbacks: {
                    title: (context) => {
                      let title = "";
                      context.forEach((elem, i) => {
                        if (i + 1 === context.length) {
                          title += elem.label;
                        } else {
                          title += elem.label + ", ";
                        }
                      });
                      return title;
                    },
                  },
                },
              },
            }}
          />
        </Box>
        <Typography
          variant="subtitle2"
          gutterBottom
          align="center"
          color="primary"
        >
          {chartName}
        </Typography>
      </Paper>
    </Box>
  );
}
